import React from 'react';
import { Layout } from 'antd';
import AddWebsiteIndexEntryWizard from '../websiteIndexEntry/wizard/AddWebsiteIndexEntryWizard';
import useGetCurrentWebsite from '../websiteIndexEntry/hooks/useGetCurrentWebsite';
import AddNewWebsiteForm from '../websiteIndexEntry/AddNewWebsiteForm';
import LoaderCard from '../shared/LoaderCard';
import WebsiteIndexEntryTabs from '../websiteIndexEntry/WebsiteIndexEntryTabs';

const { Content } = Layout;

export default function NewWebsitePage() {
    const { website, isLoading, setSelectedWebsite } = useGetCurrentWebsite();
    const websiteGuid = website?.guid;

    return (
        <Content className="general-layout-content">
            <React.Fragment key={websiteGuid}>
                {isLoading && <LoaderCard />}

                {!isLoading && !websiteGuid && (
                    <AddWebsiteIndexEntryWizard
                        websiteGuid={websiteGuid}
                        onAddDomain={setSelectedWebsite}
                    />
                )}

                {!isLoading && websiteGuid && (
                    <>
                        <AddNewWebsiteForm onFinish={setSelectedWebsite} />
                        <WebsiteIndexEntryTabs>
                            <AddWebsiteIndexEntryWizard
                                websiteGuid={websiteGuid}
                                onAddDomain={setSelectedWebsite}
                            />
                        </WebsiteIndexEntryTabs>
                    </>
                )}
            </React.Fragment>
        </Content>
    );
}
